import Vue from 'vue'
import PublicView from "@/Pages/Forms/PublicView";
function parseQuery(queryString) {
    let query = {};
    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}

const currentScript = document.currentScript;

if (currentScript) {
    const scriptUrl = new URL(currentScript.src);
    const scriptQuery = parseQuery(currentScript.src.split('?')[1]);
    const formId = scriptQuery.formId;
    const multiple = scriptQuery.multiple;
    let id = "";
    if (multiple !== null && multiple !== undefined){
        id = scriptQuery.id + "-" + formId;
    }
    else {
        id = scriptQuery.id
    }
    const container = document.getElementById(id);

    if (container) {
        fetch(scriptUrl.origin + '/api/form/' + formId + '/data').then(response => {
            response.json().then(data => {
                data.origin = scriptUrl.origin;
                new Vue({
                    render: h => h(PublicView, { props: { formData: data } })
                }).$mount(container);
            });
        });
    } else {
        console.error("No container found for ID:", id);
    }
}

